/**
 * Coarse-pointer / mobile product-card hover.
 * Desktop uses CSS :hover to crossfade the second media + soft zoom.
 * Touch and in-view use .is-uk-card-active for the same effect.
 */
(() => {
  const CARD = 'product-card, .product-card, .predictive-search-results__card--product';
  const ACTIVE = 'is-uk-card-active';
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const cards = () => document.querySelectorAll(CARD);

  const preloadSecondImage = (card) => {
    const imgs = card.querySelectorAll(
      '.card-gallery slideshow-slide.uk-card-hover-image img, .resource-card__image--secondary'
    );
    imgs.forEach((img) => {
      if (img instanceof HTMLImageElement && img.loading === 'lazy') {
        img.removeAttribute('loading');
      }
    });
  };

  const clearActive = (except) => {
    cards().forEach((card) => {
      if (card !== except) card.classList.remove(ACTIVE);
    });
  };

  const isCoarse = () => !finePointer.matches;

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!isCoarse() || event.pointerType === 'mouse') return;
      const card = event.target instanceof Element ? event.target.closest(CARD) : null;
      if (!card) return;
      clearActive(card);
      preloadSecondImage(card);
      card.classList.add(ACTIVE);
    },
    { passive: true }
  );

  if (!('IntersectionObserver' in window)) return;

  const observed = new WeakSet();
  const io = new IntersectionObserver(
    (entries) => {
      if (!isCoarse()) return;
      entries.forEach((event) => {
        const card = event.target;
        if (event.isIntersecting && event.intersectionRatio >= 0.62) {
          preloadSecondImage(card);
          card.classList.add(ACTIVE);
        } else if (!card.matches(':active')) {
          card.classList.remove(ACTIVE);
        }
      });
    },
    {
      threshold: [0.35, 0.62, 0.85],
      rootMargin: '-12% 0px -22% 0px',
    }
  );

  const observeNew = () => {
    cards().forEach((card) => {
      if (observed.has(card)) return;
      observed.add(card);
      preloadSecondImage(card);
      io.observe(card);
    });
  };

  observeNew();

  const root = document.getElementById('MainContent') || document.body;
  const mo = new MutationObserver(() => observeNew());
  mo.observe(root, { childList: true, subtree: true });

  finePointer.addEventListener('change', () => {
    if (finePointer.matches) clearActive();
    else observeNew();
  });
})();
